module.exports = __webpack_public_path__ + "img/probability_up_en.76ea23e3.png";